// frontend/src/utils/youtube.js
// Links de YouTube para la pantalla informativa: se pega cualquier link (video, short, vivo o
// lista) y de acá sale qué tiene que cargar el reproductor del TV (ver VideoPantalla).

const ID_VIDEO = /^[A-Za-z0-9_-]{6,}$/;
const ID_LISTA = /^[A-Za-z0-9_-]{10,}$/;

/**
 * Saca el id del video y/o de la lista de un link de YouTube. Acepta watch?v=, youtu.be/,
 * shorts/, live/, embed/ y ?list=. Devuelve null si no es un link de YouTube reconocible.
 */
export function analizarUrlYoutube(url) {
    if (!url || !String(url).trim()) return null;
    let texto = String(url).trim();
    if (!/^https?:\/\//i.test(texto)) texto = `https://${texto}`;

    let direccion;
    try {
        direccion = new URL(texto);
    } catch {
        return null;
    }

    const host = direccion.hostname.toLowerCase().replace(/^www\.|^m\./, '');
    let videoId = null;
    if (host === 'youtu.be') {
        videoId = direccion.pathname.split('/')[1] || null;
    } else if (host === 'youtube.com') {
        const partes = direccion.pathname.split('/').filter(Boolean);
        if (partes[0] === 'watch') {
            videoId = direccion.searchParams.get('v');
        } else if (['shorts', 'live', 'embed'].includes(partes[0])) {
            videoId = partes[1] || null;
        }
    } else {
        return null;
    }

    const listaId = direccion.searchParams.get('list');
    const resultado = {
        videoId: videoId && ID_VIDEO.test(videoId) ? videoId : null,
        listaId: listaId && ID_LISTA.test(listaId) ? listaId : null,
        inicio: segundosDeInicio(direccion.searchParams.get('t') || direccion.searchParams.get('start')),
    };
    return resultado.videoId || resultado.listaId ? resultado : null;
}

/** El "&t=" de un link compartido desde un minuto puntual: "1913", "1913s" o "31m53s". */
function segundosDeInicio(valor) {
    if (!valor) return null;
    if (/^\d+s?$/.test(valor)) return parseInt(valor, 10) || null;
    const partes = /^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/.exec(valor);
    if (!partes) return null;
    const [, horas = 0, minutos = 0, segundos = 0] = partes;
    return Number(horas) * 3600 + Number(minutos) * 60 + Number(segundos) || null;
}

/** Miniatura del video para la cola en la configuración. */
export function miniaturaYoutube(video) {
    return video?.videoId ? `https://img.youtube.com/vi/${video.videoId}/mqdefault.jpg` : null;
}
